<template>
    <Collapse accordion class="collapse-slider mt-20">
        <CollapseItem :title="complaintTitle" :name="complaintTitle">
            <div class="complaint-content mt-15">
                <div class="complaint-card mb-10" v-for="(complaint, index) in complaintsForCurrentDrop" :key="complaint.id">
                    <div class="header">
                        <div class="flex-center">
                            <div class="icon-list">
                                <svgicon name="icon-comment" style="color: red;" width="18" height="18" />
                            </div>
                            <div class="list-content">
                                <div class="col col-md">
                                    <strong> {{ complaint.complaint_type }} </strong>
                                </div>
                                <div class="col col-md">
                                    <span class="text-grey-dark">{{ $moment(complaint.created_at).format("DD MMM YYYY -hh:mm A") }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="attachment">
                            <Attachments :attachments="getFilteredAttachments(complaint.attachments)" :multiple="true"
                                :disableUpload="true" :readOnly="true" :smallIcons="true" :showPreview="true">
                            </Attachments>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="d-flex header">
                            <div class="flex-item">
                                <span class="text-sm detail-label"> {{ $t('P_CODE') }} :
                                </span>
                                <span class="text-sm  text-bold">{{ complaint.material_code }} </span>
                            </div>
                            <div class="flex-item">
                                <span class="text-sm detail-label"> {{ $t('INDENT_BATCH_ID') }} : </span>
                                <span class="text-sm  text-bold">{{ complaint.batch_id }} </span>
                            </div>
                        </div>
                        <div class="d-flex header">
                            <div class="flex-item">
                                <span class="text-sm detail-label"> {{ $t('PLANNING_QUANTITY') }} | {{ $t('MDM_UOM') }} :
                                </span>
                                <span class="text-sm text-bold">{{ complaint.quantity }} | {{ complaint.quantity_uom }}
                                </span>
                            </div>
                            <div class="flex-item">
                                <span class="text-sm detail-label"> {{ $t('OPTIMA_AMOUNT') }} ({{ currentClient.currency_icon }}) : </span>
                                <span class="text-sm  text-bold">{{ complaint.amount || 0 }} </span>
                            </div>
                        </div>
                        <div class="d-flex header">
                            <div class="flex-item">
                                <span class="text-sm detail-label"> {{ $t('PLANNING_DELIVERY_NUMBER') }} :
                                </span>
                                <span class="text-sm text-bold">{{ complaint.delivery_number || ' - ' }}
                                </span>
                            </div>
                            <div class="flex-item">
                                <span class="text-sm detail-label"> {{ $t('INVOICE_NUMBER') }}  : </span>
                                <span class="text-sm  text-bold">{{ complaint.invoice_number || ' - ' }} </span>
                            </div>
                        </div>
                        <div class="d-flex header">
                            <div class="flex-item">
                                <span class=" text-sm detail-label" >{{ $t('CCTV_LINK') }} : </span>
                                <span class=" text-sm text-bold" style="color: #376F99;"><a :href="complaint.cctv_link" target="_blank"> {{ complaint.cctv_link || ' - '}}</a></span>
                            </div>
                        </div>
                        <div class="d-flex header">
                            <div class="flex-item">
                                <span class=" text-sm" style="color: #376F99;">{{ $t('REMARKS') }}</span>
                            </div>
                        </div>
                        <div class="d-flex description text-md">
                            <div class="des">
                                {{ complaint.complaint_description }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CollapseItem>
    </Collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import Attachments from '@common/components/Attachments';

export default {
  components: {
    Attachments,

  },
  props: ['complaints', 'complaintsForCurrentDrop'],
  computed: {
    ...mapGetters({
      isComplaintsLoading: 'order/isComplaintsLoading',
      currentClient: 'app/currentClient',
    }),
    complaintTitle() {
      return `Complaints - ${this.complaintsForCurrentDrop[0].complaint_no}`;
    },
  },
  methods: {
    getFilteredAttachments(attachments) {
      if (!attachments.length) {
        return [];
      }
      return attachments.map(att => ({
        id: att.id,
        name: att.name,
        url: att.attachment_url,
      }));
    },
  },

};
</script>
<style lang="scss" scoped>
.tab-content {
    overflow-y: auto;
    height: 81vh;
    position: fixed;
    width: 50%;
}

.complaint-card {
    background: white;
    border-radius: 2px;
    border: 1px solid #e5e5e5;
    padding: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.icon-list {
    display: flex;
    align-items: center;
    width: 4rem;
    align-items: center;
    justify-content: center;
    color: white;
    height: 4rem;
    // padding: 0.1rem;
    border-radius: 50%;
    border: 0.5px solid #E9F1F5;
    background: #F8F8F8;
}

.attachment {
    display: flex;
    padding: 4px 8px;
    align-items: center;
    gap: 5px;
    border-radius: 12px;
    border: 0.5px solid #E9F1F5;
    background: #F8F8F8;
}

.card-body {
    flex-direction: column;
    align-items: start;
}

.detail-label {
    color: #333333;
    white-space: nowrap;
}

.status-badge {
    background-color: #DCFCE7;
    color: #166534;
    padding: 4px 12px;
    border-radius: 5px;
    font-size: 10px;
    border: 1px solid #BBF7D0;
    display: flex;
    padding: 0.5px 2px;
    align-items: center;
    gap: 10px;
}

.description {
    color: #4a4a4a;
    line-height: 1.0;
        background: #F9FAFA;
}

.des {
    margin-left: 5px;
    margin: 0.5em 1em;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: #F9FAFA;
    border-radius: 3px;
}

.complaint-card:hover {
    background: #EEF2F4;
    border-radius: 2px;
    border: 1px solid #E2EAEC;
    padding: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.complaint-content {
    width: 60%;
    height: 30vh;
    overflow: auto;
}
</style>
